var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loadingBox",staticStyle:{"background-color":"rgba(0, 0, 0, 0.2)"}},[_c('div',{staticClass:"sun-loading"})])}
var staticRenderFns = []

export { render, staticRenderFns }